// extracted by mini-css-extract-plugin
export var active = "Header-module--active--a63a2";
export var arrowUpAndDown = "Header-module--arrow-up-and-down--c9c91";
export var clientPortalButton = "Header-module--clientPortalButton--72d8a";
export var ctaButton = "Header-module--ctaButton--f24cb";
export var desktopMenu = "Header-module--desktopMenu--fc551";
export var dropDownMenuWrapper = "Header-module--dropDownMenuWrapper--25090";
export var dropDownMenuWrapperWindow = "Header-module--dropDownMenuWrapperWindow--4eb60";
export var header = "Header-module--header--3c27c";
export var headerContainer = "Header-module--headerContainer--28a42";
export var headerWithMenuLarge = "Header-module--headerWithMenuLarge--d118f";
export var headerWithMenuMedium = "Header-module--headerWithMenuMedium--a90cc";
export var headerWithMenuSmall = "Header-module--headerWithMenuSmall--174de";
export var hiddenNavigation = "Header-module--hiddenNavigation--5b876";
export var html = "Header-module--html--aa309";
export var languageLink = "Header-module--languageLink--4145e";
export var linksContainer = "Header-module--linksContainer--a513c";
export var logoContainer = "Header-module--logoContainer--ca573";
export var logoLink = "Header-module--logoLink--c3aff";
export var logoWrapper = "Header-module--logoWrapper--0a231";
export var menuButton = "Header-module--menuButton--a8d77";
export var menuOpen = "Header-module--menuOpen--7b2aa";
export var multilingueContainer = "Header-module--multilingueContainer--f3b6e";
export var stickyHeader = "Header-module--stickyHeader--1dd85";
export var visuallyHidden = "Header-module--visuallyHidden--c08f3";
export var withOpaqueBackground = "Header-module--withOpaqueBackground--8b6a0";